( function( $ ) {

	/*
	 * String.format was deprecated in GF 2.7.1 and will be removed in GF 2.8 in favor of String.prototype.gformFormat.
	 *
	 * As we support older versions of GF, we need to add String.prototype.gformFormat if it doesn't exist.
	 */
	if (!String.prototype.gformFormat) {
		String.prototype.gformFormat = function () {
			var args = arguments;
			return this.replace(/{(\d+)}/g, function (match, number) {
				return typeof args[number] != 'undefined' ? args[number] : match;
			});
		};
	}

	/**
	 * Whether the active version of Gravity Forms ships the products module (GF 3.0+).
	 * GF 3.0 deprecated the whole legacy pricing API.
	 */
	function hasProductsModule() {
		return typeof GPECF !== 'undefined' && !! GPECF.hasProductsModule;
	}

	/**
	 * Update gformIsHidden() to recognize GF 3.1.3+ conditionally-hidden e-commerce fields and pages,
	 * which use data-conditional-logic="hidden" instead of display:none.
	 */
	gform.addFilter( 'gform_is_hidden', function( isHidden, element ) {

		var $element = $( element );

		if ( ! $element.is( '.ginput_tax_input, .ginput_subtotal_input, .ginput_discount_input' ) ) {
			return isHidden;
		}

		var $field = $element.closest( '.gfield' );
		var $page = $field.closest( '.gform_page' );
		var isFieldHiddenByConditionalLogic = $field.attr( 'data-conditional-logic' ) === 'hidden';
		var isPageHiddenByConditionalLogic = $page.attr( 'data-conditional-logic' ) === 'hidden';

		if ( ! isHidden && ( isFieldHiddenByConditionalLogic || isPageHiddenByConditionalLogic ) ) {
			return true;
		}

		return isHidden;
	} );

	/**
	 * The Gravity Forms products module, or null if it isn't available yet.
	 *
	 * GF 3.0 ships the products module as its own bundle, so it can still be missing while the rest of the form
	 * initializes — conditional logic runs on render before the bundle has executed. Callers treat null as
	 * "nothing to calculate yet"; gform_post_render polls for the price fields and recalculates once they're up.
	 */
	function getProductsModule() {

		if ( ! hasProductsModule() || ! rgars( window, 'gform/products/getTotal' ) ) {
			return null;
		}

		return window.gform.products;
	}

	/**
	 * GetDiscount is not called using the form ID which means it's not available to the gform_coupons_discount_amount
	 * filter.
	 *
	 * This is a workaround to crawl up the stack trace when GetDiscount is called to get the form ID so we can use it
	 * when filtering gform_coupons_discount_amount to exclude shipping and discounts from the coupon amount.
	 *
	 * Ideally, Gravity Forms passes the form ID to GetDiscount and subsequently the gform_coupons_discount_amount JS
	 * filter.
	 */
	var GetDiscountOriginal = window.GetDiscount;
	var getDiscountCurrentFormId;

	window.GetDiscount = function () {
		var caller = arguments.callee.caller;

		while (caller.name !== 'PopulateDiscountInfo') {
			if (typeof caller.caller !== 'function') {
				break;
			}

			caller = caller.caller;
		}

		if (caller.name === 'PopulateDiscountInfo') {
			getDiscountCurrentFormId = caller.arguments[1];
		}

		var result = GetDiscountOriginal.apply(this, arguments);

		getDiscountCurrentFormId = undefined;

		return result;
	}

	/**
	 * Override gformGetPrice to guard against trying to get the price of a non-string value which throws an exception.
	 * Without this, the jQuery.each() loops in gformCalculateProductPrice() can fail and will stop processing rather
	 * than skipping.
	 *
	 * Only needed on GF 2.x. On GF 3.0+ we no longer call gformCalculateProductPrice().
	 */
	if ( ! hasProductsModule() ) {

		const gformGetPriceOriginal = window.gformGetPrice;

		window.gformGetPrice = function(text){
			if (typeof text !== 'string') {
				return 0;
			}

			return gformGetPriceOriginal(text);
		}

	}

	/*
	 * Memoization based on fast-memoize: https://github.com/caiogondim/fast-memoize.js/blob/master/src/index.js
	 */
	function memoize (fn, options) {
		var cache = options && options.cache
			? options.cache
			: cacheDefault

		var serializer = options && options.serializer
			? options.serializer
			: serializerDefault

		var strategy = options && options.strategy
			? options.strategy
			: strategyDefault

		return strategy(fn, {
			cache: cache,
			serializer: serializer
		})
	}

	//
	// Strategy
	//

	function isPrimitive (value) {
		return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
	}

	function monadic (fn, cache, serializer, arg) {
		var cacheKey = isPrimitive(arg) ? arg : serializer(arg)

		var computedValue = cache.get(cacheKey)
		if (typeof computedValue === 'undefined') {
			computedValue = fn.call(this, arg)
			cache.set(cacheKey, computedValue)
		}

		return computedValue
	}

	function variadic (fn, cache, serializer) {
		var args = Array.prototype.slice.call(arguments, 3)
		var cacheKey = serializer(args)

		var computedValue = cache.get(cacheKey)
		if (typeof computedValue === 'undefined') {
			computedValue = fn.apply(this, args)
			cache.set(cacheKey, computedValue)
		}

		return computedValue
	}

	function assemble (fn, context, strategy, cache, serialize) {
		return strategy.bind(
			context,
			fn,
			cache,
			serialize
		)
	}

	function strategyDefault (fn, options) {
		var strategy = fn.length === 1 ? monadic : variadic

		return assemble(
			fn,
			this,
			strategy,
			options.cache.create(),
			options.serializer
		)
	}

	function strategyVariadic (fn, options) {
		var strategy = variadic

		return assemble(
			fn,
			this,
			strategy,
			options.cache.create(),
			options.serializer
		)
	}

	function strategyMonadic (fn, options) {
		var strategy = monadic

		return assemble(
			fn,
			this,
			strategy,
			options.cache.create(),
			options.serializer
		)
	}

	//
	// Serializer
	//

	function serializerDefault () {
		return JSON.stringify(arguments)
	}

	//
	// Memoize Cache
	//

	function ObjectWithoutPrototypeCache () {
		this.cache = Object.create(null)
	}

	ObjectWithoutPrototypeCache.prototype.has = function (key) {
		return (key in this.cache)
	}

	ObjectWithoutPrototypeCache.prototype.get = function (key) {
		return this.cache[key]
	}

	ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
		this.cache[key] = value
	}

	var cacheDefault = {
		create: function create () {
			return new ObjectWithoutPrototypeCache()
		}
	}
	/**
	 * End fast-memoize functions/methods
	 */

	/**
	 * Run calculations immediately so things like {subtotal} are available for conditional logic.
	 */
	$(document).on('gform_pre_conditional_logic', function( event, formId ) {
		runCalculations( formId );
	})

	/**
	 * Replace {coupons}, {discounts}, and {subtotal} merge tags in calculation formulas.
	 */
	gform.addFilter(
		'gform_calculation_formula',
		function( formula, formulaField, formId, calcObj ) {

			if ( ! hasOurMergeTags( formula ) ) {
				return formula;
			}

			var $field          = $( '#field_{0}_{1}'.gformFormat( formId, formulaField.field_id ) ),
			isCalculatedProduct = $field.hasClass( 'gfield_price' );

			// Don't bother trying to calculate Calculated Product fields until the product fields are known.
			if ( isCalculatedProduct && ! getPriceFieldIds( formId ).length ) {
				formula = formula.replace( /{coupons}/gi, 0 );
				formula = formula.replace( /{discounts}/gi, 0 );
				formula = formula.replace( /{subtotal}/gi, 0 );
				return formula;
			}

			var couponCode = gformIsHidden( $( '#gf_coupon_code_' + formId ) ) ? '' : $( '#gf_coupon_codes_' + formId ).val(),
			hasCoupon      = couponCode != '' || $( '#gf_coupons_' + formId ).val() != '',
			total          = $( '#gf_total_no_discount_' + formId ).val(),
			couponsTotal   = 0,
			discountsTotal = getDiscountsTotal( formId, getSubtotal( formId ) ) * -1;

			// Catch cases where there are multiple forms on a page and current form does not have a Coupon field.
			if ( typeof total !== 'undefined' && hasCoupon && window['PopulateDiscountInfo'] ) {
				couponsTotal = PopulateDiscountInfo( total, formId );
			}

			formula = formula.replace( /{coupons}/gi,   parseFloat( couponsTotal ) );
			formula = formula.replace( /{discounts}/gi, parseFloat( discountsTotal + couponsTotal ) );
			formula = formula.replace( /{subtotal}/gi,  parseFloat( getSubtotal( formId, isCalculatedProduct ? [ formulaField.field_id ] : null ) ) );

			return formula;
		}
	);

	/**
	 * Exclude Shipping & Discounts from Coupons by default.
	 *
	 * @todo Gravity Forms added `formId` as a 6th parameter so we can get rid of our `getDiscountCurrentFormId` hack
	 *       whenever we're ready. See: https://github.com/gravityforms/gravityformscoupons/pull/29
	 */
	gform.addFilter(
		'gform_coupons_discount_amount',
		function( discount, couponType, couponAmount, price, totalDiscount ) {
			/**
			 * This variable is set above in our override of GetDiscount. The Form ID isn't passed to this filter
			 * by default and this is our workaround to get it.
			 */
			if (!getDiscountCurrentFormId) {
				return discount;
			}

			var formId    = getDiscountCurrentFormId,
			shippingTotal = getShippingTotal( formId ),
			total         = price + totalDiscount - shippingTotal,
			//discountTotal = getDiscountsTotal( formId, total ) * -1, // make it positive
			price = Math.max( 0, price - shippingTotal /*- discountTotal*/ );

			if ( couponType == 'percentage' ) {
				discount = price * Number( ( couponAmount / 100 ) );
			} else if ( couponType == 'flat' ) {
				discount = Number( couponAmount );
				// Price maybe fetched as 0 in an early page load scenario, which would reset discount to 0. Triggering other miscalculations.
				if ( discount > price && price != 0 ) {
					discount = price;
				}
			}

			return discount;
		}
	);

	/**
	 * Process Subtotal Fields
	 */
	gform.addFilter(
		'gform_product_total',
		function( total, formId ) {

			var $subtotalFields = $( '#gform_wrapper_' + formId + ' .ginput_subtotal_input' );

			$subtotalFields.each(
				function() {

					var origValue = $( this ).val();

					if ( gformIsHidden( $( this ) ) ) {
						if ( origValue !== 0 && origValue !== '0' ) {
							$( this ).val( 0 ).trigger( 'change' );
						}
						return true;
					}

					var subtotal = getFieldTotal(
						{
							intent:          'Calculating subtotal for Subtotal field {0}'.gformFormat( $( this ). attr( 'id' ) ),
							total:           total,
							formId:          formId,
							amount:          null,
							amountType:      null,
							productsType:    $( this ).data( 'productstype' ),
							products:        $( this ).data( 'products' ),
							includeShipping: false,
							fieldId:         gf_get_input_id_by_html_id( $( this ).attr( 'id' ) ),
						}
					);

					if ( String( origValue ) != String( subtotal ) ) {
						$( this ).val( subtotal ).trigger( 'change' );
					}

				}
			);

			return total;
		},
		48
	);

	/**
	 * Process Discount Fields
	 */
	gform.addFilter(
		'gform_product_total',
		function( total, formId ) {

			var totalDiscount = getDiscountsTotal( formId, total );

			total += totalDiscount;

			return Math.max( 0, total );
		},
		49
	);

	/**
	 * PayPal Checkout flow requires that the discount amount be specifically sent otherwise it will error during
	 * validation.
	 */
	if (window.GPECF.ppcpRequiresDiscountFilter === 'true') {
		gform.addFilter(
			'gform_ppcp_discount_total',
			function( discountTotal, formId ) {
				return discountTotal + (getDiscountsTotal( formId, getSubtotal( formId ) ) * -1);
			}
		);
	}

	/**
	 * Process Tax Fields
	 *
	 * Tax fields are not included in the Total by default. Any time the total changes,
	 * reapply our Tax fields to the total.
	 */
	gform.addFilter(
		'gform_product_total',
		function( total, formId ) {

			var $taxFields = $( '#gform_wrapper_' + formId + ' .ginput_tax_input' ),
			totalTax       = 0;

			$taxFields.each(
				function() {

					var origValue = $( this ).val();

					if ( gformIsHidden( $( this ) ) ) {
						if ( origValue !== 0 && origValue !== '0' ) {
							$( this ).val( 0 ).trigger( 'change' );
						}
						return true;
					}

					var tax;

					// Don't calculate tax when the total is 0 and we are excluding products. Avoids issues with negative numbers...
					// In the future, we might consider handling this inside getFieldTotal().
					if ( total == 0 && $( this ).data( 'productstype' ) === 'exclude' ) {
						tax = 0;
					} else {
						tax = getFieldTotal(
							{
								intent:           'Calculating tax for Tax field {0}'.gformFormat( $( this ). attr( 'id' ) ),
								total:            total,
								formId:           formId,
								amount:           $( this ).data( 'amount' ),
								amountType:       $( this ).data( 'amounttype' ),
								products:         $( this ).data( 'products' ),
								productsType:     $( this ).data( 'productstype' ),
								// Always true to match the backend (GF_Field_Tax::add_taxes). The excluded products'
								// total must be discounted too; otherwise the full, undiscounted amount is subtracted
								// from an already-discounted total, understating the tax.
								includeDiscounts: true,
								fieldId:          gf_get_input_id_by_html_id( $( this ).attr( 'id' ) ),
								includeShipping:  window.GPECF.includeShippingInTax,
							}
						);
					}

					// Convert to number to avoid issues with floating point numbers.
					tax = gformRoundPrice( tax );

					if ( String( origValue ) !== String( tax ) ) {
						$( this ).val( tax ).trigger( 'change' );
					}

					totalTax += tax;

				}
			);

			total += totalTax;

			return round( total, window.gf_global?.gf_currency_config?.decimals ?? 2 );
		},
		51 /* coupons applied at 50 */
	);

	/**
	 * Re-process calculations anytime a coupon code is added/removed.
	 */
	gform.addFilter(
		'gform_product_total',
		function( total, formId ) {

			var $coupons = $( '#gf_coupon_codes_{0}'.gformFormat( formId ) );

			if ( $coupons.data( 'gpecfChanged' ) ) {
				$coupons.data( 'gpecfChanged', false );
				$( document ).trigger( 'gform_post_conditional_logic' );
			}

			return total;
		}
	);

	/**
	 * Use this in the future to better optimize how calculations are reprocessed.
	 */
	// gform.addAction( 'gform_post_calculation_events', function() {
	//
	// }, 10, 4 );

	/**
	 * Global, form-agnostic calculation listeners, bound once per page load.
	 *
	 * gform_post_render fires repeatedly (every AJAX page change, GPNF child entry, etc.), so binding these inside it
	 * stacked a duplicate handler on every render and multiplied runCalculations() until the page crashed.
	 */
	var gpecfGlobalHandlersBound = false;

	function bindGlobalCalculationListeners() {

		// re-process calculations any time a price changes
		$( document ).on( 'gform_price_change.gpecf', function( event, formAndProductId, $elem ) {
			runCalculations( formAndProductId.formId );
		} );

		// re-process calculations GF 2.9 style.
		if ( window.gform && window.gform.utils && window.gform.utils.addFilter ) {
			window.gform.utils.addFilter( 'gform/products/product_changed', function( data ) {
				runCalculations( data.formId );
				return data;
			}, 10, 'gpecf_product_changed' );
		}

		/*
		 * GF 3.0 renamed the above event to gform/products/product_field_changed, so recalculate on that
		 * too. The native event is used rather than the jQuery one Gravity Forms also fires, because only
		 * the native one carries a payload with the form ID.
		 */
		document.addEventListener( 'gform/products/product_field_changed', function( event ) {
			var formId = event.detail && event.detail.formId;
			if ( ! formId ) {
				return;
			}

			/*
			 * Gravity Forms fires this event *before* it refreshes the products state, so anything reading
			 * gform.state here would see the values from the previous change. Refresh first, then calculate.
			 */
			refreshProductsState( formId ).then( () => {
				applyProductTotalFilter( formId );
				runCalculations( formId );
			} );
		} );

		// GPCP does not tigger 'gform_price_change' event when it updates the price. Use it's own action instead.
		// Slightly concerned that this may caused performances issues with conditional logic; TBD.
		gform.addAction(
			'gpcp_after_update_pricing',
			function( triggerFieldId, gpcp ) {
				runCalculations( gpcp._formId );
			},
			10,
			'gpecf_gpcp_after_update_pricing'
		);

		var inputChangeTimeout;

		// Calculated Number fields with only GPECF merge tags (e.g. {subtotal}) will not get recalculated when a
		// Calculated Product field's value changes. Listen for these changes and force calculations to run again.
		gform.addAction(
			'gform_input_change',
			function( elem, formId, fieldId ) {
				// GF ~2.4.15 and greater pass the elem that triggered the event rather than the window.
				if ( window === elem ) {
					return;
				}

				var $elem     = $( elem );
				var isProduct = $elem.attr( 'id' ) && $elem.attr( 'id' ).indexOf( 'ginput_base_price' ) === 0,
				isCalculation = $elem.parents( '.gfield' ).hasClass( 'gfield_calculation' );

				/**
				 * Prevent recursion.
				 */
				if ($( elem ).data('gpecfIsCalculating')) {
					return;
				}

				if ( isProduct && isCalculation ) {
					$( elem ).data('gpecfIsCalculating', true);

					/**
					 * gpecfIsCalculating along with the setTimeout is here to prevent an N+1-esq issue where every
					 * calculated product results in runCalculations firing
					 */
					if (inputChangeTimeout) {
						clearTimeout(inputChangeTimeout);
						inputChangeTimeout = undefined;
					}

					inputChangeTimeout = setTimeout(function() {
						runCalculations( formId );

						$( elem ).data('gpecfIsCalculating', false);
					}, 5);
				}
			},
			10,
			'gpecf_input_change'
		);
	}

	/**
	 * Bind our custom listeners after the form is rendered.
	 */
	$( document ).on(
		'gform_post_render',
		function( event, formId ) {

			reprioritizeWCGFProductAddon();

			// Queue a recalculation when a coupon changes. Rebound per render because the coupon element is recreated.
			$( '#gf_coupon_codes_{0}'.gformFormat( formId ) )
				.off( 'change.gpecf' )
				.on( 'change.gpecf', function() {
					$( this ).data( 'gpecfChanged', true );
				} );

			if ( ! gpecfGlobalHandlersBound ) {
				bindGlobalCalculationListeners();
				gpecfGlobalHandlersBound = true;
			}

			/*
			 * Re-process calculations once GF has registered the pricing fields.
			 *
			 * On GF 3.0+, "registered" means more than the price fields being in the DOM: every product total is
			 * read out of gform.state, which the products bundle populates asynchronously after the form renders.
			 * Calculating before that lands resolves every product to 0, and since this is the only pass that
			 * recalculates formula fields using our merge tags (nothing changes afterwards on a form that is just
			 * sitting there), a {subtotal} field would keep that 0 for the life of the page. So wait for the state
			 * too — and give up waiting after a while so forms that never populate it still get their one pass.
			 */
			var priceFieldsRegisteredAttempts = 0;
			var priceFieldsRegisteredInterval = setInterval(
				function() {
					if ( ! getPriceFieldIds( formId ).length ) {
						return;
					}

					var hasProductsState = ! hasProductsModule() || ( !! getProductsModule() && !! getProductsState( formId ) );

					if ( ! hasProductsState && ++priceFieldsRegisteredAttempts < 100 ) {
						return;
					}

					clearInterval( priceFieldsRegisteredInterval );

					/*
					 * The products state can be a render behind the form (a Calculated Product sets its price after
					 * GF first populates the state), so refresh it before reading any total out of it.
					 */
					refreshProductsState( formId ).then( function() {
						applyProductTotalFilter( formId );
						runCalculations( formId );
					} );
				},
				50
			);

			// Some browsers (like FireFox) save the values that were previously entered but do not trigger a change event.
			// Let's force a change event on form render so displayed prices always match input value.
			$( '#gform_wrapper_' + formId ).find( '.ginput_subtotal_input, .ginput_discount_input, .ginput_tax_input' ).trigger( 'change' );

		}
	);

	function getFieldTotal( args ) {

		args = parseArgs(
			args,
			{
				intent:           '',
				total:            0,
				formId:           null,
				amount:           null,
				amountType:       null,
				products:         null,
				productsType:     null,
				includeShipping:  true,
				includeDiscounts: false,
				calculateByProduct: false,
				fieldId:          null,
			}
		);

		var fieldTotal     = 0,
			productsAmount = Array.isArray( args.products ) && args.products.length > 0 ? getProductsTotal( args.formId, args.products, args.includeDiscounts ) : 0;

		if ( ! args.amount ) {
			args.amount = 0;
		}

		if ( ! args.includeShipping ) {
			args.total -= getShippingTotal( args.formId );
		}

		switch ( args.productsType ) {
			case 'include':
				args.total = productsAmount;
				break;
			case 'exclude':
				args.total -= productsAmount;
				break;
		}

		switch ( args.amountType ) {
			// used by subtotal field
			case null:
				fieldTotal = args.total;
				break;
			case 'percent':
				fieldTotal = args.total * ( args.amount/ 100 );
				break;
			default:
				var amount = args.amount;
				/**
				 * Calculate the amount by the percentage of the total.
				 */
				if ( args.calculateByProduct ) {
					var orderTotal      = getSubtotal( args.formId ),
						totalPercentage = ( args.total * 100 ) / orderTotal;
					amount             *= ( totalPercentage / 100 );
				}
				fieldTotal = amount;
		}

		fieldTotal = Math.max( 0, parseFloat( fieldTotal ) );

		return gform.applyFilters( 'gpecf_field_total', fieldTotal, args );
	}

	/**
	 * Ask Gravity Forms 3.0 to calculate a form's product total when the form has no Total field.
	 *
	 * Every calculation in this perk hangs off the gform_product_total filter. GF 2.x applied that filter
	 * whenever a price field changed, but GF 3.0 only applies it while populating a Total field — so on a
	 * form without one, none of these fields would ever be calculated. Asking GF for the total applies the
	 * filter as a side effect.
	 *
	 * A no-op on GF 2.x, and on forms that do have a Total field, where GF handles this itself.
	 */
	function applyProductTotalFilter( formId ) {

		if ( ! rgars( window, 'gform/products/getTotal' ) || $( '.ginput_total_' + formId ).length ) {
			return;
		}

		gform.products.getTotal( formId );
	}

	/**
	 * Get the IDs of a form's product fields.
	 *
	 * Gravity Forms 2.x populates window._gformPriceFields. GF 3.0 deprecated it in favor of an internal
	 * products module and leaves it empty, so fall back to reading the product fields off the form itself.
	 * Every product field carries a gfield_product_{formId}_{fieldId} class; so do the Option fields
	 * belonging to a product, which is why the IDs are de-duplicated.
	 *
	 * On GF 3.0 that registry isn't just empty, it's unreliable: gformCalculateTotalPrice() repopulates it by
	 * scanning every .gfield_price node, which includes the Total field and its empty product ID. Read the
	 * form instead, where the pattern below requires digits.
	 */
	function getPriceFieldIds( formId ) {

		if ( ! hasProductsModule() && window['_gformPriceFields'] && window['_gformPriceFields'][ formId ] ) {
			return window['_gformPriceFields'][ formId ];
		}

		var ids     = [],
			pattern = new RegExp( 'gfield_product_' + formId + '_(\\d+)' );

		$( '#gform_wrapper_' + formId ).find( '[class*="gfield_product_' + formId + '_"]' ).each( function() {
			var match = pattern.exec( this.className );
			if ( match && $.inArray( match[1], ids ) === -1 ) {
				ids.push( match[1] );
			}
		} );

		return ids;
	}

	/**
	 * Bring the Gravity Forms products state in sync with the form's current values.
	 *
	 * On GF 3.0 our totals are read out of gform.state rather than off the DOM, so they're only as accurate as
	 * the last state refresh. Gravity Forms refreshes state itself, but not always before the hooks we
	 * calculate on — gform/products/product_field_changed is dispatched *before* GF calls updateProducts(),
	 * and conditional logic doesn't refresh products at all. Calling updateProducts() ourselves re-reads the
	 * form and is idempotent, so the extra pass is safe where GF was going to refresh anyway.
	 *
	 * Resolves once state is current. A no-op on GF 2.x, where every total is read off the DOM at call time.
	 */
	function refreshProductsState( formId ) {

		const products = getProductsModule();

		if ( products && products.updateProducts ) {
			/*
			 * Always resolve. A failed refresh means we calculate against slightly stale state, which is far
			 * better than an unhandled rejection taking down every calculation queued behind it.
			 */
			return Promise.resolve( products.updateProducts( formId ) ).catch( ( e ) => {
				console.debug( 'Unable to refresh the products state for form ID ' + formId, e );
			} );
		}

		return Promise.resolve();
	}

	/**
	 * Force Gravity Forms to recalculate the Total when only derived fields change.
	 *
	 * Refreshes the products state and notifies subscribers without changing product data,
	 * avoiding stale totals and infinite loops with calculated products.
	 */
	function forceProductTotalRecalculation( formId ) {

		const previousProducts = getProductsState( formId );

		return refreshProductsState( formId ).then( () => {
			const currentProducts = getProductsState( formId );

			/*
			 * updateProducts() replaces this reference and notifies subscribers when product state changes. Only force
			 * a notification when its deep-equality check kept the existing state, otherwise subscribers run twice.
			 */
			if ( previousProducts === currentProducts ) {
				notifyProductsStateSubscribers( formId );
			}
		} );
	}

	/**
	 * Which of each form's Subtotal, Tax and Discount fields were hidden as of the last conditional logic pass,
	 * keyed by the input's HTML id.
	 */
	var ecommerceFieldVisibility = {};

	/**
	 * Whether conditional logic has shown or hidden any of the form's Subtotal, Tax or Discount fields since the last
	 * time this was asked.
	 *
	 * Those fields are the only part of the total that Gravity Forms' products state doesn't track, so they're the only
	 * reason to force the Total to repaint after conditional logic. Anything else conditional logic changes, Gravity
	 * Forms picks up itself when it refreshes the products state at the end of the pass.
	 */
	function hasEcommerceFieldVisibilityChanged( formId ) {

		var visibility = getEcommerceFieldVisibility( formId );

		var hasChanged = ecommerceFieldVisibility[ formId ] !== undefined && visibility !== ecommerceFieldVisibility[ formId ];

		ecommerceFieldVisibility[ formId ] = visibility;

		return hasChanged;
	}

	/**
	 * The current hidden/visible state of the form's Subtotal, Tax and Discount inputs as a sorted, comma-joined
	 * string of "inputId:state" pairs, so it can be compared across conditional logic passes.
	 */
	function getEcommerceFieldVisibility( formId ) {

		return $( '#gform_wrapper_' + formId )
			.find( '.ginput_tax_input, .ginput_subtotal_input, .ginput_discount_input' )
			.map( function() {
				return $( this ).attr( 'id' ) + ':' + ( gformIsHidden( $( this ) ) ? 'hidden' : 'visible' );
			} )
			.get()
			.sort()
			.join( ',' );
	}

	/**
	 * Whether conditional logic has shown or hidden the Subtotal, Tax or Discount field the given element belongs
	 * to since the last conditional logic pass.
	 *
	 * Used by gform_post_conditional_logic_field_action, which fires for every target of a pass whether or not the
	 * pass's own callback runs — which is how an animated pass that shows or hides one of our fields recalculates
	 * the Total at all on Gravity Forms 3.1.3.
	 *
	 * Fires only when the field's state actually flipped. A pass that re-applies the same visibility, or one whose
	 * end-of-pass callback already ran hasEcommerceFieldVisibilityChanged(), reads back the snapshot and is a no-op.
	 */
	function hasEcommerceFieldVisibilityChangedForElement( formId, targetId ) {

		var $target = $( targetId ).find( '.ginput_tax_input, .ginput_subtotal_input, .ginput_discount_input' );

		if ( ! $target.length ) {
			return false;
		}

		var snapshot = ( ecommerceFieldVisibility[ formId ] || '' ).split( ',' ).filter( Boolean );

		return $target.toArray().some( function( input ) {
			return snapshot.indexOf( $( input ).attr( 'id' ) + ':' + ( gformIsHidden( $( input ) ) ? 'hidden' : 'visible' ) ) === -1;
		} );
	}

	/**
	 * Get the products state's stored reference so we can tell whether Gravity Forms replaced it.
	 */
	function getProductsState( formId ) {

		return rgars( window, 'gform/state/data/' + formId + '/products' );
	}

	/**
	 * Re-run products callbacks without changing state, forcing an update for derived fields
	 * (Subtotal, Tax, Discount) that Gravity Forms does not track.
	 */
	function notifyProductsStateSubscribers( formId ) {

		const getState  = rgars( window, 'gform/state/get' ),
			callbacks = rgars( window, 'gform/state/callbacks' );

		if ( ! getProductsModule() || ! getState || ! Array.isArray( callbacks?.[ formId ] ) ) {
			return;
		}

		callbacks[ formId ].forEach( function( subscriber ) {
			if ( ! subscriber || ! Array.isArray( subscriber.keys ) || subscriber.keys.indexOf( 'products' ) === -1 ) {
				return;
			}

			const changes = {};

			subscriber.keys.forEach( function( key ) {
				const currentValue = getState( formId, key );

				/*
				 * Match Gravity Forms' callback contract: every watched key is present, products receives separate
				 * previous/current clones as the changed key, and unchanged keys share one cloned value.
				 */
				changes[ key ] = {
					prev:  key === 'products' ? getState( formId, key ) : currentValue,
					value: currentValue,
				};
			} );

			try {
				subscriber.callback( formId, 'products', changes );
			} catch ( e ) {
				console.debug( 'Unable to notify a products state subscriber for form ID ' + formId, e );
			}
		} );
	}

	/**
	 * Get the calculated total for a single product field, including its Options and quantity.
	 *
	 * GF 3.0's gform.products.getTotal() returns the product's total straight from state when passed a product
	 * ID, and — unlike the formwide call — returns before applying the gform_product_total filter, so this
	 * can't recurse back into our own filters.
	 *
	 * It also treats a falsy product ID as the whole-form total rather than an unknown product, the opposite of
	 * the GF 2.x function it replaces, so an unresolvable ID has to contribute nothing here.
	 */
	function getProductTotal( formId, productId ) {

		if ( ! productId ) {
			return 0;
		}

		if ( hasProductsModule() ) {
			const products = getProductsModule();
			return products ? products.getTotal( formId, productId ) : 0;
		}

		return gformCalculateProductPrice( formId, productId );
	}

	var getProductsTotal = function(formId, productIds, includeDiscounts) {
		if ( ! getPriceFieldIds( formId ).length ) {
			return 0;
		}
		return getProductsTotalMemoized(parseInt(formId), productIds, includeDiscounts, getProductsCacheKey( formId ))
	}

	/**
	 * Build the cache key from both form values and the GF 3.0 products state.
	 *
	 * Prevents stale products state from caching a total that should be recalculated,
	 * such as when GPNF updates a Calculated Product before the products state is refreshed.
	 */
	function getProductsCacheKey( formId ) {

		var formValues = jQuery( 'form#gform_' + formId ).serializeArray();

		if ( ! hasProductsModule() ) {
			return formValues;
		}

		return [ formValues, rgars( window, 'gform/state/get' ) ? gform.state.get( formId, 'products' ) : null ];
	}

	var getProductsTotalMemoized = memoize(function( formId, productIds, includeDiscounts, fieldValues ) {

		if ( typeof productIds == 'undefined' ) {
			productIds = getPriceFieldIds( formId );
		} else if ( ! Array.isArray( productIds ) ) {
			productIds = [ productIds ];
		}

		if ( ! productIds ) {
			return 0;
		}

		var total = 0;

		for ( var i = 0; i < productIds.length; i++ ) {
			/*
			 * Wrap in a try/catch as gformCalculateProductPrice() can generate an error if the product field does not
			 * have a value.
			 */
			try {
				const productTotal = getProductTotal( formId, productIds[i] );
				total           += productTotal;
				if ( includeDiscounts ) {
					var discountsTotal = Math.abs( getDiscountsTotal( formId, productTotal, productIds[i] ) ),
						couponsTotal = jQuery( '#gf_coupons_' + formId ).val() ? getCouponsTotal( formId, productTotal ) : 0;
					// A coupon can never discount a product by more than the product's own total. Flat coupons
					// otherwise return their full amount here (e.g. $100 off a $0 product), which mirrors neither
					// GFCoupons::get_discount() nor the resulting backend tax.
					couponsTotal     = Math.min( couponsTotal, productTotal );
					total           -= ( discountsTotal + couponsTotal );
				}
			} catch (e) {
				console.debug( 'Unable to re-calculate price for product ID ' + productIds[i] );
				continue;
			}
		}

		return total;
	});

	function getSubtotal( formId, excludeProductIds ) {

		var rawSubtotal          = getProductsTotal( formId ),
			excludeProductsTotal = typeof excludeProductIds != 'undefined' && excludeProductIds ? getProductsTotal( formId, excludeProductIds ) : 0;

		return rawSubtotal - excludeProductsTotal;
	}

	function getShippingTotal( formId ) {

		if ( hasProductsModule() ) {
			const products = rgars( window, 'gform/state/get' ) ? gform.state.get( formId, 'products' ) : null;
			return products && products.shipping ? products.shipping.price : 0;
		}

		return gformGetShippingPrice( formId );
	}

	/**
	 * Get the discount for all products or for a specific product.
	 *
	 * @param formId
	 * @param total
	 * @param productId
	 * @returns {number}
	 */
	function getDiscountsTotal( formId, total, productId ) {

		var $discountFields = $( '#gform_wrapper_' + formId + ' .ginput_discount_input' ),
			totalDiscount   = 0;

		$discountFields.each(
			function() {

				var origValue = $( this ).val(),
				productIds    = $( this ).data( 'products' ),
				productsType  = $( this ).data( 'productstype' );

				if ( gformIsHidden( $( this ) ) ) {
					if ( origValue !== 0 && origValue !== '0' ) {
						$( this ).val( 0 ).trigger( 'change' );
					}
					return true;
				}

				// If productId is passed, only calculate total discount for specified product and only when that product
				// has a total greater than 0 (discounts should never deduct value below zero).
				if ( productId && productIds ) {
					if ( productsType == 'include' && ( $.inArray( productId, productIds ) === -1 || parseInt( total ) === 0 ) ) {
						return true;
					} else if ( productsType == 'exclude' && ( $.inArray( productId, productIds ) !== -1 || parseInt( total ) === 0 ) ) {
						return true;
					}
				}

				var calculateByProduct = productId && productId > 0,
				discount               = getFieldTotal(
					{
						intent:          'Calculating discount for Discount field {0}'.gformFormat( $( this ). attr( 'id' ) ),
						total:           total,
						formId:          formId,
						amount:          $( this ).data( 'amount' ),
						amountType:      $( this ).data( 'amounttype' ),
						products:        productIds,
						productsType:    productsType,
						includeShipping: false,
						calculateByProduct: calculateByProduct,
						fieldId:         gf_get_input_id_by_html_id( $( this ).attr( 'id' ) ),
					}
				);

				// Product-specific discounts should never be greater than the product total. Only necessary for flat discounts.
				if ( productsType === 'include' && productIds.length > 0 ) {
					discount = Math.min( getProductsTotal( formId, productIds, false ), discount );
				}

				discount = gformRoundPrice( discount ) * -1;

				/**
				 * Modify the calculated discount for a Discount field.
				 *
				 * @since 1.0.23
				 *
				 * @param float  discount The total for the current Discount field.
				 * @param object $field   The jQuery object for the current Discount field.
				 */
				discount = gform.applyFilters( 'gpecf_discount_total', discount, $( this ) );

				if ( ! calculateByProduct && String( origValue ) !== String( discount ) ) {
					$( this ).val( discount ).trigger( 'change' );
				}

				totalDiscount += discount;

			}
		);

		return totalDiscount;
	}

	function getCouponsTotal( formId, total ) {

		var coupons       = window[ 'gf_coupons' + formId ],
			code,
			coupon,
			couponDiscount,
			totalDiscount = 0;

		for ( code in coupons ) {
			if ( coupons.hasOwnProperty( code ) ) {
				coupon         = coupons[ code ];
				couponDiscount = GetDiscount( coupon['type'], coupon['amount'], total, totalDiscount );
				totalDiscount += couponDiscount;
			}
		}

		return totalDiscount;
	}

	var runCalculations = function( formId ) {

		var _GFCalc = rgars( window, 'gf_global/gfcalc/{0}'.gformFormat( formId ) );
		if ( ! _GFCalc ) {
			return;
		}

		var formulaFields = [];

		for ( var i = 0; i < _GFCalc.formulaFields.length; i++ ) {
			var field = _GFCalc.formulaFields[i];
			if ( hasOurMergeTags( field.formula ) ) {
				formulaFields.push( field );
			}
		}

		if ( formulaFields.length ) {
			_GFCalc.runCalcs( formId, formulaFields );
		}

	};

	function hasOurMergeTags( formula ) {

		var hasCouponsMergeTag   = formula.search( '{coupons}' ) != -1,
			hasDiscountsMergeTag = formula.search( '{discounts}' ) != -1,
			hasSubtotalMergeTag  = formula.search( '{subtotal}' ) != -1;

		return hasCouponsMergeTag || hasDiscountsMergeTag || hasSubtotalMergeTag;
	}

	function parseArgs( args, defaults ) {

		for ( key in defaults ) {
			if ( defaults.hasOwnProperty( key ) && typeof args[ key ] == 'undefined' ) {
				args[ key ] = defaults[ key ];
			}
		}

		return args;
	}

	/**
	 * @link http://www.jacklmoore.com/notes/rounding-in-javascript/
	 * @param value
	 * @param decimals
	 * @returns {number}
	 */
	function round( value, decimals ) {
		return Number( Math.round( value + 'e' + decimals ) + 'e-' + decimals );
	}

	function reprioritizeWCGFProductAddon() {
		if ( window.gform ) {
			var filters = window.gform.hooks.filter.gform_product_total;
			for ( var filter in filters ) {
				if ( filters.hasOwnProperty( filter ) ) {
					if ( filters[ filter ].callable.toString().indexOf( 'update_dynamic_price_ajax' ) !== -1 ) {
						// Set priority after everything else we do.
						filters[ filter ].priority = 52;
					}
				}
			}
		}
	}

	/**
	 * Recalculate our fields and the Total after conditional logic has run, on GF 3.0+.
	 *
	 * On GF 3.0+, gformCalculateTotalPrice() is deprecated. Its job here — force everything to recalculate,
	 * whether or not a product changed — is what forceProductTotalRecalculation() does, and repainting the
	 * Total field applies gform_product_total, which is what recalculates our fields.
	 *
	 * applyProductTotalFilter() covers forms with no Total field, where there's nothing to repaint and so
	 * nothing applies gform_product_total; runCalculations() covers formula fields using our merge tags,
	 * which are not driven by that filter at all.
	 *
	 * Only force the repaint when it can change the Total. Repainting fires a change event on the Total input,
	 * which re-runs conditional logic for any field that depends on the Total, which lands back here. Forcing on
	 * every pass turned that into an endless loop that froze the form. The products state is still refreshed on
	 * every pass, as calculations using our merge tags read their totals out of it.
	 */
	function recalculateAfterConditionalLogic( formId, isInit ) {

		var hasVisibilityChanged = hasEcommerceFieldVisibilityChanged( formId );
		var recalculation        = isInit || hasVisibilityChanged ? forceProductTotalRecalculation( formId ) : refreshProductsState( formId );

		recalculation.then( () => {
			applyProductTotalFilter( formId );
			runCalculations( formId );
		} );
	}

	// With GF 2.9, state management has been added and `gform_product_total` does not trigger with conditional logic changes.
	jQuery(document).on('gform_post_conditional_logic', function(event, formId, fields, isInit) {

		if ( hasProductsModule() ) {
			recalculateAfterConditionalLogic( formId, isInit );
			return;
		}

		gformCalculateTotalPrice( formId );
	});

	/*
	 * GF 3.1.3 stopped animating fields with Visibility set to Hidden, and when the form animates conditional logic
	 * it skips the callback that fires gform_post_conditional_logic along with the animation. A pass that shows or
	 * hides one of our Visibility: Hidden fields, such as a Discount field applied by a coupon code, would leave the
	 * Total without it, and the form would then fail Total validation on submit. Recalculate when one of our fields
	 * is shown or hidden instead of waiting for a pass that may never finish.
	 *
	 * gform_post_conditional_logic_field_action is the right hook: Gravity Forms fires it for every target of every
	 * pass whether or not the pass's callback ran, including when the callback was skipped.
	 *
	 * The callback isn't always skipped, though. When the pass's last dependent is animated to show and is already
	 * visible, slideDown( callback ) no-ops but still invokes the callback, so gform_post_conditional_logic fires a
	 * slide's length late rather than never. This handler is what recalculates the Total immediately on that pass;
	 * the delayed gform_post_conditional_logic then lands as a no-op because hasEcommerceFieldVisibilityChanged()
	 * has already snapshotted the new visibility. If this handler is ever removed, forms whose last dependent
	 * animates to show recalculate a slide late again — and on GF 3.1.3's hidden-visibility skips, not at all.
	 */
	gform.addAction( 'gform_post_conditional_logic_field_action', function( formId, action, targetId, defaultValues, isInit ) {

		if ( ! hasProductsModule() || isInit || ! hasEcommerceFieldVisibilityChangedForElement( formId, targetId ) ) {
			return;
		}

		// Wait for the rest of the pass, so a pass that shows or hides several of our fields recalculates once.
		Promise.resolve().then( () => recalculateAfterConditionalLogic( formId, false ) );
	} );

} )( jQuery );
